import React, {useState} from 'react'
import PartNumber from 'pu-react/components/PartNumber';
import Revision from 'pu-react/components/Revision'
import StencilFile from 'pu-react/components/StencilFile';
import LengthText from "pu-react/components/carriers/LengthText";
import WidthText from "pu-react/components/carriers/WidthText";
import PrintConfirmation from 'pu-react/components/PrintConfirmationRadio';
import SpecialInstruction from 'pu-react/components/SpecialInstruction'
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import RowSelected        from 'pu-react/components/RowSelected';
import ColumnSelected     from 'pu-react/components/ColumnSelected';
import MaterialThickness from 'pu-react/components/carriers/MaterialThickness';
import RequiredInformation from "pu-react/components/RequiredInformation";
import Hardware from './Hardware';

const Parameters = (props) => {
  const {parameters, validator} = props
  const [zipFile, setZipFile] = useState(parameters.filename)

  validator.purgeFields();

  const onChangeFile = (event) => {
    const file = event.target.files[0];
    setZipFile(file ? file.name : null);
  }
  return (
    <div>
      <div className="row">
        <div className="col-12 col-lg-6">
          <PartNumber {...props}>
            {validator.message(`Part Number`, parameters.part_number, 'required|min:3')}
          </PartNumber>
        </div>
        <div className="col-12 col-lg-6">
          <Revision {...props} label="Revision number">
            {validator.message(`Revision`, parameters.revision, 'required')}
          </Revision>
        </div>
        <div className="col-12 col-lg-6">
          <MaterialThickness {...props} />
        </div>
        <div className="col-12 col-lg-6">
          <StencilFile required {...props} onChange={onChangeFile} >
            {validator.message(`Zip File`, zipFile, 'required')}
          </StencilFile>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-lg-6">
              <WidthText {...props} >
                {validator.message(`Carrier Width`, parameters.carrier_width, 'required|numeric|min:0.1,num|max:20,num')}
              </WidthText>
            </div>
            <div className="col-lg-6">
              <LengthText {...props} >
                {validator.message(`Carrier Length`, parameters.carrier_length, 'required|numeric|min:0.1,num|max:24,num')}
              </LengthText>
            </div>
          </div>
        </div>
        <div className="col-12">
          <PrintConfirmation {...props} >
            {validator.message(`Check plot confirmation`, parameters.print_confirmation, 'required')}
          </PrintConfirmation>
        </div>
        <div className="col-12">
          <Hardware {...props} validator={validator} />
        </div>

        <div className="col-12">
          <SpecialInstruction {...props} />
          <ProductQuoteNumber {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <RequiredInformation />
        </div>
      </div>
    </div>
  )
}

export default Parameters;
